import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dbClient } from '@/services/db-client';

export function useCreateCreator() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params: Record<string, unknown>) => {
            const { data, error } = await dbClient.rpc('admin_create_ghost_creator', params);
            if (error) throw new Error(error.message);
            return data as string;
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['admin', 'academy'] });
        },
    });
}
